import React, { Fragment, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary, NotFound } from '@bechtel/client-common';
import { ProjectAdminDetail } from './detail';
import { ProjectAdminList } from './list';
import { Alert } from '@bechtel/gds';
import { useProjectAdminPermissions } from './hooks';
import { Trans } from '@lingui/macro';

const ProjectAdmin = () => {
  const [isListCollapsed, setIsListCollapsed] = useState(false);
  const { canViewProjectAdmin } = useProjectAdminPermissions();
  const handleToggleCollapse = () => {
    setIsListCollapsed((state) => !state);
  };
  if (!canViewProjectAdmin)
    return (
      <Alert>
        <Trans>Sorry, you do not have permission to view project admin</Trans>
      </Alert>
    );

  return (
    <Fragment>
        <ErrorBoundary>
          <Routes>
            <Route path=":id/*" element={<ProjectAdminDetail isListCollapsed={isListCollapsed} />}></Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorBoundary>
        <ErrorBoundary>
          <ProjectAdminList isListCollapsed={isListCollapsed} onToggleCollapse={handleToggleCollapse} />
        </ErrorBoundary>
    </Fragment>
  );
};

export default ProjectAdmin;
